export default __webpack_public_path__ + "files/015736ac96a0f4b445b58b17ba1a2dec.woff2";